import {
  getQueryStringParamsFromStringUrl,
  logger,
  PermissionType,
} from '$utils'
import { defer } from 'react-router-dom'
import useAppStore, { isAppStateReady } from 'src/state/store'
import useStockStore from '../../../store'
import { CombineOption } from '../_common/helpers/combineOption'
import { ExportType } from '../_common/helpers/exportType'
import { AccountingSystem, AuthModule } from '$constants'
import { ThirdPartyConnectionStatus } from '$models'

export default async function loader({ request }) {
  logger.debug(
    '[loader] About to await AppState being ready in Export To loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Export To loader')

  const {
    combine,
    accountingSystem,
    exportType,
    supplierIds,
    supplierStatementIds,
    invoiceIds,
    purchaseOrderIds,
  } = getQueryStringParamsFromStringUrl(request.url)

  const { activeCompany } = useAppStore.getState()
  const hasStockPermission =
    activeCompany?.hasPermission(PermissionType.Stock) ?? false

  const xeroConnection = useStockStore
    .getState()
    .checkExternalSystemConnection(AuthModule.Stock, AccountingSystem.Xero)
    .then((result) => {
      if (!result?.hasAuth || !hasStockPermission) return
      const promises: Promise<void>[] = [
        useStockStore.getState().getSuppliers(),
        useStockStore.getState().getCategories(),
        useStockStore.getState().getThirdPartyAccounts(accountingSystem),
        useStockStore.getState().getThirdPartyContacts(accountingSystem),
      ]

      useStockStore.getState().setOptions({
        combine: combine as CombineOption,
        accountingSystem: accountingSystem as AccountingSystem,
        exportType: exportType as ExportType,
        supplierIds: supplierIds ? JSON.parse(supplierIds) : [],
        supplierStatementIds: supplierStatementIds
          ? JSON.parse(supplierStatementIds)
          : [],
        invoicesIds: invoiceIds ? JSON.parse(invoiceIds) : [],
        purchaseOrdersIds: purchaseOrderIds ? JSON.parse(purchaseOrderIds) : [],
      })

      return Promise.all(promises).then(() => result)
    })

  return defer({
    data: Promise.all([xeroConnection])
      .then((result) => result as [ThirdPartyConnectionStatus | null])
      .catch((error) => {
        logger.error('Export To Promise.all error', error)
        return false
      }),
  })
}
